import React from 'react';
import Typography from '@mui/material/Typography';
import CommonCenterContainer from '../common/CommonCenterContainer';
import { styled } from '@mui/system';

const Text = styled('p')`
  padding: 1rem;
  font-size: 1rem;
  text-align: justify;
`;

const Contact = () => {
  return (
    <CommonCenterContainer>
      <Text variant="body1" paragraph>
        Jeśli masz pytania, chcesz zgłosić błąd w aplikacji lub pomysł na jej ulepszenie, daj nam znać!
      </Text>
   <Typography variant="body1" paragraph>
     Pisz do nas e-mail na adres:<br/>
     <a href="mailto:&#107;&#111;&#110;&#116;&#97;&#107;&#116;&#64;&#100;&#105;&#101;&#116;&#97;&#110;&#105;&#101;&#109;&#111;&#119;&#108;&#97;&#107;&#97;&#46;&#112;&#108;">
       &#107;&#111;&#110;&#116;&#97;&#107;&#116;&#64;&#100;&#105;&#101;&#116;&#97;&#110;&#105;&#101;&#109;&#111;&#119;&#108;&#97;&#107;&#97;&#46;&#112;&#108;
     </a>
   </Typography>


    </CommonCenterContainer>
  );
};

export default Contact;